/**
 * @desc ebs处理军团/平台接口结果反馈
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.EbsFeedBackResponseDto>;
export function request(body: defs.basics.EbsFeedBackRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/ebs/ebsCoaFeedBackResult`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
